import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Panel from './components/Panel';

const HeaderSearch = ({ triggerLabel, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleKeyboardEvents = (e) => {
    if (e.key && e.key.toLowerCase() === 'escape') {
      setIsOpen(false);
    }
  }

  const handleClickOutside = () => {
    setIsOpen(false);
  }

  useEffect(() => {
    const openSearch = () => setIsOpen(true);
    document.addEventListener('openSearch', openSearch, false);
    window.addEventListener('keydown', handleKeyboardEvents, false);
    window.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('openSearch', openSearch, false);
    };
  }, []);

  return (
    <>
      <button
        className="header-search__trigger"
        aria-label={triggerLabel}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <svg>
          <title>search trigger</title>
          <use xlinkHref="#search" />
        </svg>
      </button>
      <Panel {...props} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

HeaderSearch.propTypes = {
  triggerLabel: PropTypes.string.isRequired
};

export default HeaderSearch;
